export default __webpack_public_path__ + "static/media/seo-call.9b514309.mp3";